module.exports = __webpack_public_path__ + "img/union_card.afb183aa.jpeg";